var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ label: true, 'label--demo': _vm.env === 'demo' },on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.env)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }